import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-print\"><defs><style type=\"text/css\"></style></defs><path d=\"M358.4 128h307.2v121.6h121.6V0H236.8v249.6h121.6zM819.2 249.6H25.6v467.2h275.2v-128H166.4V377.6H857.6v211.2h-70.4v128h211.2V249.6z\" fill=\"#888888\" p-id=\"2300\" /><path d=\"M236.8 467.2V1024h556.8V467.2H236.8z m428.8 428.8H358.4V595.2h307.2V896z\" fill=\"#888888\" p-id=\"2301\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol